import React from "react";
import { HorizontalBar } from "react-chartjs-2";
import { horizontalBar } from "./_commonSharedChartOptions";
import _ from "lodash";
import { connect } from "react-redux";
import { setColor } from "../../../../views/Dashboard/dashboard/ColorPalette";
import { WidgetNoDataToDisplay, WidgetServerError } from "../../../../components/DashboardWidget/WidgetCommon";
import { sessionsByUserDataPreview } from "./_previewData";
import { sessionByUserGraph } from "./_detailsTableHeaders";

const widgetProps = {
  Chart: "NUMBER_OF_UNIQUE_SESSIONS_BY_USER",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

const widgetDetails = {
  Chart: "NUMBER_OF_UNIQUE_SESSIONS_BY_USER_DETAILS",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class UniqueSessionsByUserContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  setWidgetDataColor(data) {
    data.map(item => {
      item.backgroundColor = setColor(item.label);
    });
    return data;
  }

  render() {
    const { widgetData, draggable } = this.props;

    return (
      <div>
        <div className="widgetTitle">Sessions by Private User</div>
        <div className="widgetBody">
          {draggable ? (
            <WidgetServerError draggable={draggable} />
          ) : widgetData === undefined || draggable ? (
            <WidgetNoDataToDisplay draggable={draggable} />
          ) : (
            <HorizontalBar
              id={widgetDetails.Chart}
              data={{
                labels: widgetData.labels,
                datasets: this.setWidgetDataColor(widgetData.data_dict.Items)
              }}
              options={_.extend({}, horizontalBar, {
                hover: {
                  onHover: function(e) {
                    let point = this.getElementAtEvent(e);
                    if (point.length) e.target.style.cursor = "pointer";
                    else e.target.style.cursor = "default";
                  }
                }
              })}
            />
          )}
        </div>
      </div>
    );
  }
}

export const UniqueSessionsByUserPreview = () => {
  return (
    <div>
      <div className="widgetTitle">Sessions by User</div>
      <div className="widgetBody">
        <HorizontalBar
          data={sessionsByUserDataPreview}
          options={_.merge({}, horizontalBar, {
            legend: { display: false },
            scales: {
              yAxes: [
                {
                  ticks: {
                    fontSize: 5
                  }
                }
              ]
            },
            plugins: {
              datalabels: {
                font: {
                  size: 5
                }
              }
            }
          })}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard.data["SessionPerUserPrivate"]
  };
}

export const UniqueSessionsByUserContent = connect(
  mapStateToProps,
  undefined
)(UniqueSessionsByUserContentClass);
